import * as styles from '../../styles/components/UserTargets.less';
import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import Loader from '../common/Loader';
import { Target } from '../../types/models';

interface UserTargetsOwnProps {
  targets?: Target[];
  isLoading?: boolean;
}

// NOTE: the previous class had a `connect(...)` (commented out) and a
// show-disabled checkbox + handler (also commented out in render). Both were
// dead — this component only renders the target list from ownProps. Dropped.
const UserTargets = (props: UserTargetsOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]

  const renderTargets = () => props.targets && props.targets.map((target, i) => (
    <div key={i}>
      <Link
        className={styles.target}
        to={`/target/${target._id}`}
        key={i}>{target.name}
      </Link>
    </div>
  ));

  return (
    <div>
      <h2 className={styles.title}>
        {t('main.targets')}
      </h2>
      {props.isLoading && <Loader />}
      {renderTargets()}
    </div>
  );
};

export default withTranslation('common')(UserTargets);
